import { createContext, FC, ReactNode, useState } from 'react';
import { FaqSubject } from './types';

export interface FaqContextState {
  type: 'None' | 'FaqPage' | 'FaqPopup' | 'Custom';
  faqSubject?: FaqSubject;
  customElement?: ReactNode;
  setFaqConfig: (next: { type: 'None' | 'FaqPage' | 'FaqPopup' | 'Custom'; faqSubject?: FaqSubject; customElement?: ReactNode }) => void;
}

const FaqContext = createContext<FaqContextState>({
  type: 'None',
  setFaqConfig: () => {}
});

export const FaqContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [state, setState] = useState<{
    type: 'None' | 'FaqPage' | 'FaqPopup' | 'Custom';
    faqSubject?: FaqSubject;
    customElement?: ReactNode;
  }>({
    type: 'None'
  });
  return <FaqContext.Provider value={{ ...state, setFaqConfig: (next) => setState(next) }}>{children}</FaqContext.Provider>;
};

export default FaqContext;
